import { useEffect, useState } from "react"
import { useParams, useNavigate } from "react-router-dom"
import styled from "styled-components"
import { API } from "./FormEdit"
import toast from "react-hot-toast"
import {ProductImages} from "./EditProductImg"
import {ProductSizes} from "./ProductSizes"
import { Toaster } from "react-hot-toast"


const Select = styled.select`
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #4A4B4F;
  background-color: #3A3B3E;
  color: white;
  font-size: 1rem;

  &:focus {
    outline: none;
    border-color: #4A88F3;
  }
`


// Reutilizamos los estilos del FormEdit
const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #1E1F23;
  color: #FFFFFF;
`

const Content = styled.div`
  display: flex;
  flex: 1;
  padding: 20px;
  gap: 20px;
  
  @media (max-width: 1200px) {
    flex-direction: column;
  }
`

// Reutilizamos los demás estilos del FormEdit...
const FormSection = styled.div`
  margin-top: 20px;
  flex: 2;
`

const ImageSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const Form = styled.form`
  display: flex;
  margin-top: 30px;
  flex-direction: column;
  gap: 20px;
`

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const Label = styled.label`
  font-size: 0.9rem;
`

const Input = styled.input`
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #4A4B4F;
  background-color: #3A3B3E;
  color: white;
  font-size: 1rem;

  &:focus {
    outline: none;
    border-color: #4A88F3;
  }
`

const Switch = styled.input.attrs({ type: 'checkbox' })`
  width: 40px;
  height: 20px;
  appearance: none;
  background-color: #4A4B4F;
  border-radius: 10px;
  position: relative;
  cursor: pointer;
  
  &:checked {
    background-color: #4A88F3;
  }

  &:before {
    content: '';
    width: 16px;
    height: 16px;
    background-color: white;
    position: absolute;
    border-radius: 50%;
    top: 2px;
    left: 2px;
    transition: 0.3s;
  }

  &:checked:before {
    left: 22px;
  }
`

const ColorInput = styled(Input)`
  height: 40px;
  padding: 5px;
`

const Button = styled.button`
  padding: 12px 20px;
  border-radius: 4px;
  border: none;
  background-color: #4A88F3;
  color: white;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #3B78E0;
  }

  &:disabled {
    background-color: #4A4B4F;
    cursor: not-allowed;
  }
`

const FormSection2Columns = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

const TextArea = styled.textarea`
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #4A4B4F;
  background-color: #3A3B3E;
  color: white;
  font-size: 1rem;
  min-height: 100px;
  resize: vertical;

  &:focus {
    outline: none;
    border-color: #4A88F3;
  }
`

export default function ScooterForm({ create }) {
  const { id } = useParams()
  const [scooter, setScooter] = useState({
    nombre: '',
    descripcion: '',
    sku: '',
    precio: '',
    precioAntes: '',
    peso: '',
    isScooter: true,
    foldable: false,
    status: 0,
    frame_material: '',
    net_weight: '',
    size: '',
    motor_power: '',
    battery_type: '',
    battery_capacity: '',
    charger: '',
    range: '',
    charging_time: '',
    certificate: '',
    max_speed: '',
    tyre_type: '',
    brake_type: '',
    lights: '',
    wrap: '',
    box_size: '',
    shelves: false,
    board_material: '',
    logo_customization: false,
    max_load: '',
    voltage: '',
    max_climbing_angle: '',
    motor_drive: '',
    img: [],
    colores: [],
    tallas: [],
    fecha: '',
    categorias: ''
  })
  
  const navigate = useNavigate()

  // Función auxiliar para formatear la fecha ISO a formato YYYY-MM-DD
  const formatDateForInput = (isoDate) => {
    if (!isoDate) return ''
    return isoDate.split('T')[0]
  }

  useEffect(() => {
    if (id && !create) {
      fetch(`${API}/api/productos/productos/${id}`)
        .then(res => res.json())
        .then(data => {
          const parsedData = {
            ...data.producto,
            img: typeof data.producto.img === 'string' ? JSON.parse(data.producto.img) : (data.producto.img || []),
            tallas: typeof data.producto.tallas === 'string' ? JSON.parse(data.producto.tallas) : (data.producto.tallas || []),
            colores: typeof data.producto.colores === 'string' ? JSON.parse(data.producto.colores) : (data.producto.colores || []),
            precio: data.producto.precio || '',
            precioAntes: data.producto.precioAntes || '',
            fecha: formatDateForInput(data.producto.fecha) || '',
            categorias: data.producto.categorias || '',
            descripcion: data.producto.descripcion || '',
            nombre: data.producto.nombre || '',
            sku: data.producto.sku || '',
            frame_material: data.producto.frame_material || '',
            net_weight: data.producto.net_weight || '',
            size: data.producto.size || '',
            motor_power: data.producto.motor_power || '',
            battery_type: data.producto.battery_type || '',
            battery_capacity: data.producto.battery_capacity || '',
            charger: data.producto.charger || '',
            range: data.producto.range || '',
            charging_time: data.producto.charging_time || '',
            certificate: data.producto.certificate || '',
            max_speed: data.producto.max_speed || '',
            tyre_type: data.producto.tyre_type || '',
            brake_type: data.producto.brake_type || '',
            lights: data.producto.lights || '',
            isScooter: true,
            foldable: data.producto.foldable || false
          }
          setScooter(parsedData)
        })
        .catch(error => {
          console.error('Error fetching scooter:', error)
          toast.error('Error al cargar los datos del scooter')
        })
    }
  }, [id, create])

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target
    setScooter(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }))
  }

  const handleColorChange = (index, color) => {
    const newColors = [...scooter.colores]
    newColors[index] = color
    setScooter(prev => ({
      ...prev,
      colores: newColors
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c3VhcmlvIjp7ImlkIjoxfSwiaWF0IjoxNzM5NjI5MjE1LCJleHAiOjE3Mzk3MTU2MTV9.E9XX1oOng0xRc5XwxVcNEHpUstDX6YMK-jvguoSscYg'
    }

    try {
      // Aseguramos que los arrays existan, si no, usamos arrays vacíos
      const imgArray = Array.isArray(scooter.img) ? scooter.img : []
      const tallasArray = Array.isArray(scooter.tallas) ? scooter.tallas : []
      const coloresArray = imgArray.length > 0 ? imgArray.map(img => img.color || '') : []

      if (!create) {
        // Para edición, siempre incluimos los arrays parseados
        const productToUpdate = {
          ...scooter,
          img: JSON.stringify(imgArray),
          tallas: JSON.stringify(tallasArray),
          colores: JSON.stringify(coloresArray)
        }

        const response = await fetch(`${API}/api/productos/${id}`, {
          method: 'PUT',
          headers,
          body: JSON.stringify(productToUpdate)
        })

        const updatedProduct = await response.json()
        toast.success('Scooter actualizada con éxito')
        navigate('/administracion/1')
      } else {
        // Para creación, incluimos los arrays vacíos parseados
        const productToCreate = {
          ...scooter,
          img: JSON.stringify(imgArray),
          tallas: JSON.stringify(tallasArray),
          colores: JSON.stringify(coloresArray),
          precioAntes: Number(scooter.precioAntes || 0),
          precio: Number(scooter.precio || 0)
        }

        const response = await fetch(`${API}/api/productos/`, {
          method: 'POST',
          headers,
          body: JSON.stringify(productToCreate)
        })

        const createdProduct = await response.json()
        toast.success('Scooter creada con éxito')
        navigate(`/administracion/scooter-edit/${createdProduct.producto.id}`)
      }
    } catch (error) {
      console.error('Error:', error)
      toast.error(error.message || 'Error al guardar')
    }
  }

  const handleAddImage = (newImage) => {
    setScooter(prev => ({
      ...prev,
      img: [...prev.img, newImage]
    }))
  }

  const handleDeleteImage = async (image) => {
    if (scooter) {
      const formData = new FormData();
      formData.append('url', image.url.public_id);
      formData.append('id', id);
      const pet = await fetch(`${API}/api/productos/delete/image`,{
        method: 'POST',
        headers: {
           "Authorization": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c3VhcmlvIjp7ImlkIjoxfSwiaWF0IjoxNzM5NjI5MjE1LCJleHAiOjE3Mzk3MTU2MTV9.E9XX1oOng0xRc5XwxVcNEHpUstDX6YMK-jvguoSscYg"
        },
        body: formData
      })
      const images = await pet.json()
      scooter.colores = images.img.map((img) => img.color)
      setScooter({ ...scooter, img: images.img })
      toast.success('Imagen eliminada con éxito')
    }
  }

  const handleEditImage = async (index, editedImage) => {
    if (scooter) {
      const formData = new FormData();
      formData.append('file', editedImage.url);
      formData.append('oldImg', JSON.stringify(scooter.img[index].url));
      formData.append('id', id);
      formData.append('color', editedImage.color);
      formData.append('isPrimary', editedImage.isPrimary);
      const pet = await fetch(`${API}/api/productos/update/image`,{
        method: 'POST',
        headers:{
           "Authorization": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c3VhcmlvIjp7ImlkIjoxfSwiaWF0IjoxNzM5NjI5MjE1LCJleHAiOjE3Mzk3MTU2MTV9.E9XX1oOng0xRc5XwxVcNEHpUstDX6YMK-jvguoSscYg"
        },
        body: formData
      })
      const imageNew = await pet.json()
      toast.success('Imagen actualizada con éxito')
      scooter.colores[index] = imageNew.img.color
      const newImages = [...scooter.img]
      imageNew.img.isPrimary = imageNew.img.isPrimary === "true"
      newImages[index] = imageNew.img
      setScooter({ ...scooter, img: newImages })
    }
  }

  const handleAddSize = (newSize) => {
    if (scooter) {
      fetch(`${API}/api/productos/tallas`, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          newSize: JSON.stringify(newSize),
          id: id,
          operation: "create"
        })
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          toast.error(data.error)
          return
        }
        setScooter({
          ...scooter,
          tallas: [...scooter.tallas, data.newSize],
        })
        toast.success('Talla agregada con éxito');
      })
     
    }
  }

  const handleEditSize = (idx, updatedSize) => {
    if (scooter) {
      fetch(`${API}/api/productos/tallas`, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          newSize: JSON.stringify(updatedSize),
          id: id,
          operation: "edit"
        })
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          toast.error(data.error)
          return
        }
      })
    }
  }

  const handleDeleteSize = (idx) => {
    if (scooter) {
      fetch(`${API}/api/productos/tallas`, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          newSize: idx,
          id: id,
          operation: "delete"
        })
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          toast.error(data.error)
          return
        }
        const newSizes = scooter.tallas.filter((_, index) => index !== idx)
        setScooter({
          ...scooter,
          tallas: newSizes,
        })
        toast.success('Talla eliminada con éxito')
      })
    }
  }

  return (
    <PageContainer>
      <Toaster />
      <Content>
        <FormSection>
          <h1>{create ? 'Crear Nueva Scooter' : 'Editar Scooter'}</h1>
          <Form onSubmit={handleSubmit}>
            {/* Información básica */}
            <FormGroup>
              <Label htmlFor="nombre">Nombre del producto</Label>
              <Input id="nombre" name="nombre" value={scooter.nombre} onChange={handleChange} required />
            </FormGroup>

            <FormSection2Columns>
              <FormGroup>
                <Label htmlFor="sku">SKU</Label>
                <Input id="sku" name="sku" value={scooter.sku} onChange={handleChange} required />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="precioAntes">Precio Antes</Label>
                <Input
                  id="precioAntes"
                  name="precioAntes"
                  type="number"
                  value={scooter.precioAntes}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="precio">Precio Actual</Label>
                <Input
                  id="precio"
                  name="precio"
                  type="number"
                  value={scooter.precio}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
                <FormGroup>
                <Label htmlFor="status">Estado de Producto</Label>
                  <Select
                    id="status"
                    name="status"
                    value={scooter.status}
                    onChange={handleChange}
                    required
                  >
                    <option value="0" selected>Activo</option>
                    <option value="1">Inactivo</option>
                  </Select>

              </FormGroup>
            </FormSection2Columns>

            <FormGroup>
              <Label htmlFor="categorias">Categoría</Label>
              <Input
                id="categorias"
                name="categorias"
                value={scooter.categorias}
                onChange={handleChange}
              />
            </FormGroup>

            <FormGroup>
              <Label htmlFor="fecha">Fecha</Label>
              <Input 
                id="fecha" 
                name="fecha" 
                type="date" 
                value={scooter.fecha} 
                onChange={handleChange} 
              />
            </FormGroup>

            {/* Especificaciones técnicas */}
            <h2>Especificaciones Técnicas</h2>
            
            <FormSection2Columns>
              <FormGroup>
                <Label>¿Es plegable?</Label>
                <Switch
                  name="foldable"
                  checked={scooter.foldable}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Material del marco</Label>
                <Input
                  name="frame_material"
                  value={scooter.frame_material}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Peso neto</Label>
                <Input
                  name="net_weight"
                  value={scooter.net_weight}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Tamaño</Label>
                <Input
                  name="size"
                  value={scooter.size}
                  onChange={handleChange}
                />
              </FormGroup>
            </FormSection2Columns>

            {/* Especificaciones eléctricas */}
            <h2>Especificaciones Eléctricas</h2>

            <FormSection2Columns>
              <FormGroup>
                <Label>Potencia del motor</Label>
                <Input
                  name="motor_power"
                  value={scooter.motor_power}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Tipo de batería</Label>
                <Input
                  name="battery_type"
                  value={scooter.battery_type}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Capacidad de batería</Label>
                <Input
                  name="battery_capacity"
                  value={scooter.battery_capacity}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Cargador</Label>
                <Input
                  name="charger"
                  value={scooter.charger}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Autonomía</Label>
                <Input
                  name="range"
                  value={scooter.range}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Tiempo de carga</Label>
                <Input
                  name="charging_time"
                  value={scooter.charging_time}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Certificaciones</Label>
                <Input
                  name="certificate"
                  value={scooter.certificate}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Velocidad máxima</Label>
                <Input
                  name="max_speed"
                  value={scooter.max_speed}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Tipo de neumáticos</Label>
                <Input
                  name="tyre_type"
                  value={scooter.tyre_type}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Sistema de frenos</Label>
                <Input
                  name="brake_type"
                  value={scooter.brake_type}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Iluminación</Label>
                <Input
                  name="lights"
                  value={scooter.lights}
                  onChange={handleChange}
                />
              </FormGroup>
            </FormSection2Columns>

            <FormGroup>
              <Label htmlFor="descripcion">Descripción</Label>
              <TextArea
                id="descripcion"
                name="descripcion"
                value={scooter.descripcion}
                onChange={handleChange}
                required
              />
            </FormGroup>

            <Button type="submit">
              {create ? 'Crear Scooter' : 'Actualizar Scooter'}
            </Button>
          </Form>
        </FormSection>

        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <div>
            <ProductImages 
              images={scooter.img}
              create={create}
              onAddImage={handleAddImage}
              onDeleteImage={handleDeleteImage}
              onEditImage={handleEditImage}
            />
          </div>
          <div>
            <ProductSizes
              sizes={scooter.tallas}
              onAddSize={handleAddSize}
              onEditSize={handleEditSize}
              onDeleteSize={handleDeleteSize}
              create={create}
            />
          </div>
        </div>
      </Content>
    </PageContainer>
  )
}
